module.exports = {
	"en": {
		"commons": {
			"types": {
				"HOME": "All",
				"TWITTER": "Twitter",
				"CHAT": "Chat",
				"MAIL": "Email",
				"WHATSAPP": "WhatsApp",
				"MESSENGER": "Messenger",
				"TELEGRAM": "Telegram"
			},
			"ok": "OK",
			"cancel": "Cancel",
			"new-convo": "(new conversation)",
			"no-subject": "(no subject)",
			"admin": "Administrator",
			"reply": "Reply",
			"downloadzip": "Download zip file",
			"media": "Channel"
		},
		"list": {
			"no-conv": "No conversations to show"
		},
		"header": {
			"time": "Conversation time",
			"finish": {
				"action": "Finish conversation",
				"title": "Finish conversation",
				"content": "Are you sure you want to complete this operation? The conversation will be terminated and deleted.",
				"commit": "Finish"
			},
			"unassign": {
				"action": "Unassign conversation",
				"title": "Unassign conversation",
				"content": "Are you sure you want to complete this operation? The conversation will be removed from your inbox and assigned to a different agent.",
				"commit": "Unassign"
			},
			"spam": {
				"action": "Mark email as spam",
				"title": "Mark email as spam",
				"content": "Are you sure you want to complete this operation? The email will be removed from your inbox and the sender will be blocked.",
				"commit": "Mark"
			},
			"discard": {
				"action": "Discard conversation",
				"title": "Discard conversation",
				"content": "Are you sure you want to complete this operation? The conversation will be deleted and you won’t be able to recover it.",
				"commit": "Discard"
			},
			"wrapup": {
				"action": "Disposition conversation"
			},
			"view-contact": {
				"action": "View contact"
			}
		},
		"wrapup": {
			"title": "Wrap-up time",
			"select": "Save",
			"placeholder": "Select disposition",
			"placeholderSub": "Select sub-disposition",
			"end": "Finish",
			"endconversation": "Finish conversation"
		},
		"chat": {
			"no-messages": "No messages have been received yet. Wait a moment or start the conversation now.",
			"disabled": "The Administrator has disabled this conversation. You can't send or receive messages.",
			"response-placeholder": "Type your message here. ",
			"search-placeholder": "Search",
			"templates": "Templates",
			"delivered": "Delivered",
			"read": "Read",
			"can-see": "Contact can see this message",
			"cant-see": "Contact can't see this message",
			"send-enter": "Press Enter to send.",
			"newline-enter": "Press Shift + Enter to insert a line break.",
			"greetings": {
				"morning": "Good morning",
				"afternoon": "Good afternoon",
				"night": "Good evening"
			},
			"time": "[Time]",
			"drop-file": "Drop files here to attach",
			"loading": "Attaching",
			"divider-yesterday": "Yesterday",
			"divider-today": "Today",
			"loading-messsages": "Loading messages",
			"errorSize": {
				"attachErrorTitleSingle": "Unable to attach file",
				"attachErrorSingle": "Maximum file size allowed is 16 MB.",
				"attachErrorSingleWhatsapp": "Maximum file size allowed is 64 MB.",
				"attachErrorTitleMultiple": "Unable to attach files",
				"attachErrorMultiple": "Maximum size per file is 16 MB.",
				"attachErrorMultipleWhatsapp": "Maximum size per file is 64 MB.",
				"attachErrorCommit": "Close"
			},
			"errorFormat": {
				"attachErrorTitleSingle": "Unable to attach file",
				"attachErrorTitleMultiple": "Unable to attach files",
				"attachErrorMessage": "Invalid format. Supported formats are JPG, PNG, BMP, and GIF.",
				"attachErrorMessageWhatsapp": "Invalid format. Try using another image, audio, video, or document file extension.",
				"attachErrorCommit": "Close"
			}
		},
		"whatsapp": {
			"unsupported": "Content not supported",
			"notAvailable": "Content not available",
			"rejectedMessage": "Rejected by Meta",
			"unsupported-sticker": "This is a sticker, it can't be visualized.",
			"image": "Image",
			"video": "Video",
			"audio": "Audio",
			"file": "File"
		},
		"mail-editor": {
			"cc": "CC",
			"bcc": "BCC",
			"add-cc": "Add Cc recipients",
			"add-bcc": "Add Bcc recipients",
			"show-quoted": "Show trimmed content",
			"from": "From",
			"sent": "Sent",
			"to": "To",
			"subject": "Subject",
			"send": "Send",
			"format": "Formatting options",
			"attach": "Attach files",
			"link": "Insert link",
			"discard": "Discard",
			"drop-files": "Drop files here.",
			"invalid-size": "File cannot exceed 10MB",
			"unsafe-file": "Blocked for security reasons",
			"sending": "Sending email...",
			"openlink": "Open link",
			"change": "Change",
			"delete": "Remove"
		},
		"links-modal": {
			"title": "Insert link",
			"label-text": "Text to display",
			"label-url": "Web address (URL)",
			"insert": "Insert",
			"text-error": "Format error",
			"url-error": "Invalid URL"
		},
		"media-viewer": {
			"download": "Download",
			"back": "Back",
			"no-preview": "No preview available"
		},
		"new-message-bar": {
			"spam": "Mark as spam",
			"reply": "Reply",
			"unassign": "Unassign"
		},
		"contact-info": {
			"title": "Contact information",
			"phone": "Phone number",
			"data": "Additional data",
			"unassign": "Unassign conversation",
			"finish": "Finish conversation"
		}
	},
	"es": {
		"commons": {
			"types": {
				"HOME": "Todos",
				"TWITTER": "Twitter",
				"CHAT": "Chat",
				"MAIL": "Correo electrónico",
				"WHATSAPP": "WhatsApp",
				"MESSENGER": "Messenger",
				"TELEGRAM": "Telegram"
			},
			"ok": "Aceptar",
			"cancel": "Cancelar",
			"new-convo": "(nueva conversación)",
			"no-subject": "(sin asunto)",
			"admin": "Administrador",
			"reply": "Responder",
			"downloadzip": "Descargar archivo zip",
			"media": "Canal"
		},
		"list": {
			"no-conv": "No hay conversaciones para mostrar"
		},
		"header": {
			"time": "Tiempo de conversación",
			"finish": {
				"action": "Terminar conversación",
				"title": "Terminar conversación",
				"content": "¿Está seguro de que desea realizar esta operación? La conversación se cerrará y se eliminará.",
				"commit": "Terminar"
			},
			"unassign": {
				"action": "Desasignar conversación",
				"title": "Desasignar conversación",
				"content": "¿Está seguro de que desea realizar esta operación? La conversación desaparecerá de su bandeja de entrada y será asignada a otro agente.",
				"commit": "Desasignar"
			},
			"spam": {
				"action": "Marcar correo como no deseado",
				"title": "Marcar correo como no deseado",
				"content": "¿Está seguro de que desea realizar esta operación? El correo desaparecerá de su bandeja de entrada y el remitente será bloqueado.",
				"commit": "Marcar"
			},
			"discard": {
				"action": "Descartar conversación",
				"title": "Descartar conversación",
				"content": "¿Está seguro de que desea realizar esta operación? La conversación se eliminará y no podrá recuperarla.",
				"commit": "Descartar"
			},
			"wrapup": {
				"action": "Calificar conversación"
			},
			"view-contact": {
				"action": "Ver contacto"
			}
		},
		"wrapup": {
			"title": "Tiempo de notas",
			"select": "Guardar",
			"placeholder": "Seleccione una calificación",
			"placeholderSub": "Seleccione una sub calificación",
			"end": "Terminar",
			"endconversation": "Terminar conversación"
		},
		"chat": {
			"no-messages": "No se han recibido mensajes aún. Espere un momento o inicie la conversación ahora. ",
			"disabled": "El administrador ha deshabilitado la conversación. No puede enviar o recibir mensajes.",
			"response-placeholder": "Escriba su mensaje aquí.",
			"search-placeholder": "Buscar",
			"templates": "Plantillas",
			"delivered": "Entregado",
			"read": "Leído",
			"can-see": "El contacto puede ver este mensaje.",
			"cant-see": "El contacto no puede ver este mensaje.",
			"send-enter": "Presiona Entrar para enviar.",
			"newline-enter": "Presiona Mayús + Entrar para agregar un salto de línea.",
			"greetings": {
				"morning": "Buenos días",
				"afternoon": "Buenas tardes",
				"night": "Buenas noches"
			},
			"time": "[Hora]",
			"drop-file": "Suelte los archivos aquí para adjuntar",
			"loading": "Adjuntando",
			"divider-yesterday": "Ayer",
			"divider-today": "Hoy",
			"loading-messsages": "Cargando mensajes",
			"errorSize": {
				"attachErrorTitleSingle": "Error al adjuntar archivo",
				"attachErrorSingle": "El límite de tamaño permitido es de 16 MB.",
				"attachErrorSingleWhatsapp": "El límite de tamaño permitido es de 64 MB.",
				"attachErrorTitleMultiple": "Error al adjuntar archivos",
				"attachErrorMultiple": "El límite de tamaño por archivo es de 16 MB.",
				"attachErrorMultipleWhatsapp": "El límite de tamaño por archivo es de 64 MB.",
				"attachErrorCommit": "Cerrar"
			},
			"errorFormat": {
				"attachErrorTitleSingle": "Error al adjuntar archivo",
				"attachErrorTitleMultiple": "Error al adjuntar archivos",
				"attachErrorMessage": "Formato inválido. Los formatos soportados son JPG, PNG, BMP y GIF.",
				"attachErrorMessageWhatsapp": "Formato inválido. Intente con otra extensión de archivo de imagen, audio, video o documento.",
				"attachErrorCommit": "Cerrar"
			}
		},
		"whatsapp": {
			"unsupported": "Contenido no soportado",
			"notAvailable": "Contenido no disponible",
			"rejectedMessage": "Rechazado por Meta",
			"unsupported-sticker": "Este es un sticker, no se puede ver.",
			"image": "Imagen",
			"video": "Video",
			"audio": "Audio",
			"file": "Archivo"
		},
		"mail-editor": {
			"cc": "CC",
			"bcc": "CCO",
			"add-cc": "Agregar destinatarios a Cc",
			"add-bcc": "Agregar destinatarios a Cco",
			"show-quoted": "Mostrar contenido recortado",
			"from": "De",
			"sent": "Enviado",
			"to": "Para",
			"subject": "Asunto",
			"send": "Enviar",
			"format": "Opciones de formato",
			"attach": "Adjuntar archivos",
			"link": "Insertar vínculo",
			"discard": "Descartar",
			"drop-files": "Suelte los archivos aquí.",
			"invalid-size": "El archivo no puede superar los 10MB",
			"unsafe-file": "Bloqueado por motivos de seguridad",
			"sending": "Enviando correo...",
			"openlink": "Abrir vínculo",
			"change": "Modificar",
			"delete": "Eliminar"
		},
		"links-modal": {
			"title": "Insertar vínculo",
			"label-text": "Texto para mostrar",
			"label-url": "Dirección web (URL)",
			"insert": "Insertar",
			"text-error": "Error de formato",
			"url-error": "URL Inválida"
		},
		"media-viewer": {
			"download": "Descargar",
			"back": "Atrás",
			"no-preview": "No hay vista previa disponible"
		},
		"new-message-bar": {
			"spam": "Marcar como spam",
			"reply": "Responder",
			"unassign": "Desasignar"
		},
		"contact-info": {
			"title": "Información del contacto",
			"phone": "Teléfono",
			"data": "Datos adicionales",
			"unassign": "Desasignar conversación",
			"finish": "Terminar conversación"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/lang/translations.json
// module id = 2041
// module chunks = 0